module.exports = __webpack_public_path__ + "img/skill-1.e3f153d2.png";